/**
 * Project-independent i18n logic.
 * Loads up the dictionary files and provides project-independent i18n functions.
 */

/* eslint-disable no-param-reassign */
const sprintf = require('sprintf-js').sprintf;
const maybeWarn = require('./maybe-warn').maybeWarn;

const FALLBACKS = { en: 'en-gb', fr: 'fr-fr', de: 'de-at' };
const FALLBACK_LOCALE = 'en-gb';

const objectHasProp = Function.prototype.call.bind(Object.prototype.hasOwnProperty);

function getNKeyForNumber(number, string) {
  if (Math.abs(number) in string) {
    return '' + Math.abs(number);
  }
  return 'PLURAL';
}

function renderString(locale, key, string, dictionaryOptions, params) {
  if (!string) return null;

  let message = string.hasOwnProperty('message') ? string.message : string;

  // handle plurals
  if (
    typeof message !== 'string' ||
    string.pluralVariable
  ) {
    if (
      !params.length
    ) {
      maybeWarn(
        locale + '::' + key + '::invalid-plural-params',
        'Error in locale ' + locale + '::' + key + '\n' +
        'Invalid plural arguments'
      );
    } else if (
      typeof string.pluralVariable !== 'string'
    ) {
      maybeWarn(
        locale + '::' + key + '::missing-plural-variable',
        'Error in locale ' + locale + '::' + key + '\n' +
        'Missing pluralVariable'
      );
    } else if (
      typeof message === 'string'
    ) {
      maybeWarn(
        locale + '::' + key + '::invalid-plural-message',
        'Error in locale ' + locale + '::' + key + '\n' +
        'Invalid plural message format'
      );
    } else {
      let pluralValue = null;
      // If pluralVariable starts with a $ sign, get the paramter at the nth index.
      //   Otherwise, grab the value for key (pluralVariable) from the first parameter.
      if (string.pluralVariable[0] === '$') {
        pluralValue = params[string.pluralVariable.substr(1)];
      } else {
        pluralValue = params[0][string.pluralVariable];
      }
      message = message[
        (
          dictionaryOptions && dictionaryOptions.getNKeyForNumber || getNKeyForNumber
        )(
          pluralValue,
          message
        )
      ];
    }
  }

  try {
    return sprintf.apply(null, [message].concat(params));
  } catch (error) {
    maybeWarn(
      locale + '::' + key + '::error',
      'Error in locale ' + locale + '::' + key + '\n' +
      'String: ' + message + '\n' +
      'Params: ' + JSON.stringify(params) + '\n' +
      error.stack,
      true
    );
    return 'ERROR';
  }
}

function getStringForLocaleFromDictionary(dictionary, locale, key, params) {
  if (dictionary[locale] && objectHasProp(dictionary[locale].strings, key)) {
    return renderString(
      locale,
      key,
      dictionary[locale].strings[key],
      dictionary[locale].options,
      params
    );
  }

  const lang = locale && locale.split('-')[0];
  const fallbackLocale = FALLBACKS[lang];

  if (!fallbackLocale || !dictionary[fallbackLocale]) {
    maybeWarn(locale, 'Locale not supported: ' + locale);
  } else {
    if (
      objectHasProp(dictionary[fallbackLocale].strings, key)
    ) {
      return renderString(
        lang,
        key,
        dictionary[fallbackLocale].strings[key],
        dictionary[fallbackLocale].options,
        params
      );
    }
    maybeWarn(locale + '::' + key, 'String for locale not found: ' + locale + ' ' + key);
  }

  return renderString(
    FALLBACK_LOCALE,
    key,
    dictionary[FALLBACK_LOCALE].strings[key],
    dictionary[FALLBACK_LOCALE].options,
    params
  );
}

exports.getStringForLocaleFromDictionary = getStringForLocaleFromDictionary;



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/lib/i18n-common.js